import { useQuery } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { useAppLoader } from '@/routes/_app/loader.ts';
import {
  LearningProgressQuery,
  useMarkVideoWatched,
} from './use-learning-progress';
import { VideoModal } from './video-modal';

export type LearningVideo = {
  id: string;
  s3Key: string;
  title: string;
};

type LearningVideoModalProps = {
  video: LearningVideo | null;
  onClose: () => void;
};

export const LearningVideoModal = ({
  video,
  onClose,
}: LearningVideoModalProps) => {
  const { authenticated } = useAppLoader();
  const toast = useToast();
  const { markVideoWatched } = useMarkVideoWatched();
  const { data } = useQuery(LearningProgressQuery, {
    skip: !authenticated,
    fetchPolicy: 'cache-first',
  });

  const watched =
    video == null
      ? false
      : (data?.learningProgress?.videos.find((item) => item.id === video.id)
          ?.watched ?? false);

  if (video == null) {
    return null;
  }

  return (
    <VideoModal
      s3Key={video.s3Key}
      title={video.title}
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      onEnded={async () => {
        if (authenticated && !watched) {
          try {
            await markVideoWatched(video.id);
            toast.success({
              title: 'Thanks for watching! Points awarded.',
            });
          } catch {
            toast.error({ title: 'Failed to record progress.' });
          }
        }
        onClose();
      }}
    />
  );
};
